import logo from './images/Nisha_Logo.png';
import gcLogo from './images/GC-Logo.png';
import OriginalLogo from './logo/Original.png';
import BlackOnWhite from './logo/Black on White.png'

export default  {
    logo,
    gcLogo,
    OriginalLogo,
    BlackOnWhite
}